import { Navigate, useLocation } from "react-router-dom";
import { VARIANT_KEY } from "@/lib/ab";

const SPLIT_KEY = "sb_ab_split";

export default function StartSplit() {
  const { search } = useLocation();
  let v = localStorage.getItem(VARIANT_KEY) || localStorage.getItem(SPLIT_KEY);
  if (!v) { v = Math.random() < 0.5 ? "paid_original" : "free_new"; localStorage.setItem(SPLIT_KEY, v); }
  sessionStorage.setItem("sb_ab_entry", "start");
  return <Navigate to={`${v === "free_new" ? "/free" : "/welcome"}${search}`} replace />;
}
